<template>
	<div class="comp">
		<div class="L">
			<div style="line-height: 36px;text-align: center; color: #343440;font-size: 14px;font-weight: bold; cursor: pointer; margin-bottom: 10px;background-color: #F6F8FF;border-radius: 8px;" @click="drawercardAdd_state=true">
				赠送洗美卡
			</div>
			<div class="LItem" :class="curCard.card_number===item.card_number?'active':''" v-for="(item,index) in cardList" :key="index" @click="changeCurPet(item)">
				<div class="navR">
					<div class="petName">{{item.card_name}}</div>
					<div class="petMsg">
						{{item.card_number}}
					</div>
					<div class="petNum">剩余次数：{{item.surplus_count}}</div>
					<div class="petBtn">
						<i class="el-icon-edit-outline" style="font-size: 20px;" @click.stop="curCardItem=item;drawercardEdit_state=true;"></i>
						<i class="el-icon-view" slot="reference" style="font-size: 20px;margin-left: 10px;color:#577BFF;" @click="curCardItem=item;compCustomRecord_state=true"></i>
						<!-- <img class="petIcon" src="../../../../assets/img/index/headPic.jpg" /> -->
					</div>
				</div>
			</div>
		</div>
		<div class="R">
			<div class="panel">
				<div class="petDetail">
					<div class="petDetailItem">
						名称：{{curCard.card_name}}
					</div>
					<div class="petDetailItem">
						服务：{{curCard.service_name}} 
					</div>
					<div class="petDetailItem">
						规格：{{curCard.service_object_name}}
					</div>
					<div class="petDetailItem">
						卡号：{{curCard.card_number}} 
					</div>
					<div class="petDetailItem">
						类型：{{curCard.card_category&&curCard.card_category.name}}
					</div>
					<div class="petDetailItem">
						剩余次数：{{curCard.surplus_count}}
					</div>
					<div class="petDetailItem">
						状态：
						<span v-if="curCard.status===-1">删除</span>
						<span v-if="curCard.status===1">启用</span>
						<span v-if="curCard.status===0">禁用</span>
					</div>
					<div class="petDetailItem">
						截止日期：{{$public.FTime(curCard.end_date)}}
					</div>
				</div>
				<div class="searchLine">
					<div class="searchLineL">
						<div class="searchItem active" >
							<span>使用记录</span>
							<span class="searchItemActiveBar"></span>
						</div>
					</div>
					<div class="searchLineR">
						<el-button type="success" size="mini" @click="curRecordIndex=-1;drawercardRecordEdit_state=true" style="margin-top:10px;">新增使用记录</el-button>
					</div>
				</div>
				<div >
					<div class="list" v-if="$public.isNull(curCard.consume_record)" style="background-color: #fff;height: 200px;">
						<div style="padding-top:60px;text-align: center;">暂无使用记录</div>
					</div>
					<div class="list" v-else>
						<el-table :data="curCard.consume_record||[]" >
							<el-table-column label="订单编号" width="160">
								<template slot-scope="scope">
									{{scope.row.order_num}}
								</template>
							</el-table-column>
							<el-table-column label="状态" width="100">
								<template slot-scope="scope">
									{{scope.row.consume_type===0?'退回':''}}
									{{scope.row.consume_type===1?'消费':''}}
								</template>
							</el-table-column>
							<el-table-column prop="shop_name"  label="服务地点" width="200">
							</el-table-column>
							<el-table-column label="消费日期">
								<template slot-scope="scope">
									{{$public.FTime(scope.row.consume_time)}}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="60">
								<template slot-scope="scope">
									<el-button type="text" size="mini" @click="curRecordIndex=scope.$index;drawercardRecordEdit_state=true" style="margin-top:10px;">修改</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>
		<div v-if="drawercardEdit_state">
			<drawercardEdit :id="userDetail._id" :item="curCardItem" @submit="submit_drawercardEdit"></drawercardEdit>
		</div>
		<div v-if="drawercardAdd_state">
			<drawercardAdd :memberId="userDetail._id" @submit="submit_drawercardAdd"></drawercardAdd>
		</div>
		<!-- 修改洗美卡使用记录 -->
		<div v-if="drawercardRecordEdit_state">
			<drawercardRecordEdit :memberId="userDetail._id" :curCard="curCard" :curRecordIndex="curRecordIndex" @submit="submit_drawercardRecordEdit"></drawercardRecordEdit>
		</div>
		<!-- 自定义记录 -->
		<div v-if="compCustomRecord_state">
			<compCustomRecord :linkId="curCardItem.card_number" :type="5" @submit="compCustomRecord_state=false"></compCustomRecord>
		</div>
	</div>
</template>

<script>
	import drawercardEdit from "./drawer/drawer_cardEdit.vue"
	import drawercardAdd from "./drawer/drawer_cardAdd.vue"
	import drawercardRecordEdit from "./drawer/drawer_cardRecordEdit.vue"
	import compCustomRecord from "@/components/compCustomRecord.vue"
	export default {
		components:{drawercardEdit,drawercardAdd,drawercardRecordEdit,compCustomRecord},
		data() {
			return {
				cardList:[],
				
				curCard:{},
				
				// 赠送洗美卡
				drawercardAdd_state:false,
				// 修改洗美卡
				drawercardEdit_state:false,
				curCardItem:{},
				// 修改洗美卡使用记录
				drawercardRecordEdit_state:false,
				curRecordIndex:-1,
				// 自定义记录
				compCustomRecord_state:false,
			}
		},
		props:{
			userDetail:{
				default:''
			}
		},
		mounted(){
			this.getCardList();
		},
		methods:{
			// 赠送
			submit_drawercardAdd(obj){
				this.drawercardAdd_state = false;
				if(obj.type==='success'){
					this.getCardList()
				}
			},
			// 修改成长值
			submit_drawercardEdit(obj){
				this.drawercardEdit_state =false;
				if(obj.type==="success"){
					this.getCardList()
				}
			},
			// 修改洗美卡使用记录
			submit_drawercardRecordEdit(obj){
				this.drawercardRecordEdit_state =false;
				if(obj.type==="success"){
					this.getCardList()
				}
			},
			changeCurPet(item){
				this.curCard=item;
			},
			getCardList(){
				let params = {
					"member_id": this.userDetail._id,
					"isvalid": 0, // 0：不限、1：有效、2：无效
				}
				let loading = this.$loading()
				this.$http.get(process.env.VUE_APP_member + '/api/MemberBindCard/CardList', params).then(res => {
					loading.close();
					if (res.code == 0) {
						if(!this.$public.isNull(res.data)){
							this.cardList = res.data || [];
							this.curCard = this.cardList[0]
						}
						
						
					}
				})
			},
			
			
		},
	}
</script>

<style lang="scss" scoped>
	.comp{
		display: flex;margin-top:16px;height: 100%;
		.L{
			width:372px;background-color: #fff;border-radius: 16px;flex-shrink: 0;padding:24px;box-sizing: border-box;margin-right: 16px;overflow: auto;
			.LItem{
				display: flex;color:$color333;font-size: 14px;cursor: pointer;margin-bottom: 10px;height: 125px;padding:16px;box-sizing: border-box;
				&.active{
					color:#577BFF;background-color: #F6F8FF;
				}
				.navL{
					width:50px;margin-right: 16px;flex-shrink: 0;
					.petAtavar{
						width:50px;height: 50px;border-radius: 50%;
					}
					.petLevel{
						width:30px;padding:10px 10px;
					}
				}
				.navR{
					width:100%;position: relative;
					.petName{
						font-size: 16px;color:$color333;padding:6px 0;
					}
					.petMsg{
						font-size: 14px;color:$color666;padding:10px 0;
					}
					.petNum{
						font-size: 14px;color:$color999;padding:10px 0;
					}
					.petBtn{
						position: absolute;top:0;right:-6px;
						.petIcon{
							width:20px;height: 20px;margin-right: 14px;
						}
					}
				}
			}
		}
		.R{
			width:100%;background-color: #fff;border-radius: 16px;padding:16px 32px;box-sizing: border-box;
			.panel{
				position: relative;height: 100%;
				.petDetail{
					display: flex;flex-wrap: wrap;
					.petDetailItem{
						min-width: 20%;padding:16px 0;font-size: 14px;
					}
				}
				.searchLine{
					display: flex;justify-content: space-between;background-color: #fff;padding:0 0 20px;position: absolute;width:100%;box-sizing: border-box;top:85px;z-index: 1;border-top:1px solid #EBEEF5;margin-top:20px;
					.searchLineL{
						display: flex;padding-top: 16px;
						.searchItem{
							font-size: 14px;color:$color333;margin-right: 40px;cursor: pointer;
							&.active{
								color:#577BFF;
							}
							.searchItemActiveBar{
								display: block;width:18px;height: 4px;background: linear-gradient(135deg, #4BB2FF 0%, #466BFF 100%);border-radius: 3px;margin:8px auto 0;
							}
						}
					}
					.searchLineR{
						
					}
				}
				.list{
					padding-top:62px;border-radius: 16px;overflow: auto;height: calc(100% - 143px);
					.item{
						background-color: #fff;border-radius: 16px;margin-bottom:16px;padding:32px;display: flex;
						.avatarBox{
							.avatar{
								width:56px;height: 56px;border-radius: 50%;margin-right: 16px;
							}
						}
						.avatarBoxR{
							.originalName{
								font-size: 14px;color:$color333;padding-bottom:5px
							}
							.originalTime{
								font-size: 12px;color:$color999;
							}
							.originalTag{
								display: flex;padding-top:10px;
								.tagItem{
									background-color: #F7F9FA;border-radius: 12px;margin-right: 20px;display: flex;height: 22px;padding:3px 10px 3px 3px;box-sizing: border-box;line-height: 16px;
									.tagIcon{
										width:16px;height: 16px;margin-right: 5px;
									}
									.tagText{
										font-size: 12px;color:#4062E7;
									}
								}
							}
							.originalWord{
								padding-top:10px;padding-right: 50px;
								.word{
									font-size: 14px;color:$color333;line-height: 22px;
								}
							}
							.originalImg{
								padding-top:10px;padding-right: 30px;overflow: hidden;white-space: nowrap;width:625px;
								.originalImgItem{
									width:104px;height: 104px;margin-right: 4px;
								}
							}
							.originalBtn{
								display: flex;padding-top:16px;
								.num1{
									font-size: 14px;color:#333;margin-right: 16px;
								}
								.num2{
									font-size: 14px;color:$color999;margin-right: 32px;
								}
								.btn{
									font-size: 14px;color:#577BFF;margin-right: 32px;cursor: pointer;
								}
							}
						}
					}
				}
			}
			
		}
		.pagePosi{
			width:100%;text-align: right;background-color: #fff;border-radius: 8px;padding:0 10px;box-sizing: border-box;position: relative;z-index: 1;
		}
	}
</style>
